import { Button, Collapse, Grid, ListItem, Paper } from '@material-ui/core';
import IconButton from "@material-ui/core/IconButton";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Tooltip from '@mui/material/Tooltip';
import Authorize from 'components/Authorize';
import { hasPermission } from 'components/Authorize/authorizeUtil';
import { permissionProfiles } from 'components/Authorize/permissionProfiles';
import { permissions } from "components/Authorize/permissions/permissions";
import ConfirmationPopup from 'components/ConfirmationPopup';
import RowActions from 'components/DataTable/RowActions/RowActions';
import { EntityAuditTooltip } from 'components/EntityAudit/EntityAuditTooltip';
import ExportButton from "components/ExportButton/ExportButton";
import LoadButton from 'components/LoadButton/LoadButton';
import NotificationProvider from 'components/NotificationProvider';
import ReservationButton from 'components/ReservationButton/ReservationButton';
import AddActivity from "features/activity/AddActivity/AddActivity";
import { activityStatusById, activityStatuses } from 'features/activity/activityConsts';
import { useDeleteActivityMutation, useMoveToStatusMutation } from 'features/activity/activitySlice';
import { useGetAllAliasesQuery } from 'features/activity/activityStatusAliasSlice';
import ActivityStatusAliasView from 'features/activityStatusAlias/ActivityStatusAliasView';
import AttachmentsTooltip from 'features/attachments/AttachmentsTooltip';
import { AttachmentEntityTypes } from 'features/attachments/attachmentsConsts';
import { useGetClientsQuery } from 'features/clients/clientSlice';
import { FlagEntityTypes } from 'features/flag/flagsConsts';
import { ActivityPriceError } from 'features/landing/components/MechanicalDashboard/ActivityList/ActivityPriceError';
import { useGetDeletedLotsQuery, useGetLotsQuery } from 'features/lots/lotSlice';
import NotesTooltip from 'features/notes/NotesTooltip';
import { NoteEntityTypes } from 'features/notes/notesConsts';
import { useGetVehicleActivityNotesQuery } from 'features/notes/notesSlice';
import { selectIsAdmin, selectIsOwner } from 'features/user/userSlice';
import { FlagAsset } from 'features/vehicles/Flags/FlagAsset';
import VehicleStatusView from 'features/vehicles/VehicleStatus/VehicleStatusView';
import { useGetStatusesForClientQuery } from 'features/vehicles/VehicleStatus/vehicleStatusSlice';
import {
    useDeleteVehicleDetailMutation,
    useGetVehicleDetailsQuery
} from 'features/vehicles/vehicleSlice';
import { IconApprove, IconDeleteBlue, IconEdit, IconReject } from 'icons';
import { IconActivityDefault } from 'icons/mechanicals';
import { groupBy, orderBy } from 'lodash';
import React, { useState } from 'react';
import { useSelector } from "react-redux";
import { useHistory, useParams } from 'react-router-dom';
import { AutoSizer } from 'react-virtualized';
import { VariableSizeList } from 'react-window';
import FormatService from "services/formatService";
import { arrayToObject } from 'utils/object-util';
import { isAuthorized } from "../../../../components/Authorize/authorizeUtil";
import EditActivityLog from '../EditActivityLog/EditActivityLog';
import EditVehicleDetails from "../EditVehicleDetails";
import { vehicleDetailsPageStyle } from "../VehicleDetailsPageStyle";
import { vehicleActivityLogStyle } from './style';

const useResetCache = data => {
    const ref = React.useRef();
    React.useEffect(() => {
        // AutoSizer causes ref not being present on the component mount
        if (ref.current) {
            ref.current.resetAfterIndex(0);
        }
    }, [data]);
    return ref;
};


const VehicleActivityLog = ({ activityLogData, refetchActivityLog }) => {
    const classes = vehicleDetailsPageStyle();
    const activityLogClasses = vehicleActivityLogStyle();
    const history = useHistory();

    const isAdmin = useSelector(selectIsAdmin);
    const isOwner = useSelector(selectIsOwner);
    const [vehicleDetailsToEdit, setVehicleDetailsToEdit] = useState(null);
    const [activityLogToEdit, setActivityLogToEdit] = useState(null);
    const [vehicleDetailToDelete, setVehicleDetailToDelete] = useState(null);
    const [activityToDelete, setActivityToDelete] = useState(null);
    const [openPopup, setOpenPopup] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [expandedItems, setExpandedItems] = useState([]);

    let { id } = useParams();
    let { data: vehicleDetails, error, isLoading: isLoadingVehicle } = useGetVehicleDetailsQuery(id);
    // let { data: activityLogData, error: activityLogError, isLoading: isLoadingActivityLog, refetch: refetchActivityLog } = useGetActivityLogQuery(id);
    let { data: lots, error: lotError, isLoading: isLoadingLots } = useGetLotsQuery();
    let { data: deletedLots, error: deletedLotsotError, isLoading: isLoadingDeletedLots, } = useGetDeletedLotsQuery();
    let { data: clients, error: clientError, isLoading: isLoadingClients } = useGetClientsQuery(null, { skip: !isAdmin });
    let { data: allvehicleActivityNotes, error: notesError, isFetching: isLoadingNotes } = useGetVehicleActivityNotesQuery({ vehicleId: vehicleDetails?.id }, { skip: !vehicleDetails?.id });
    let { data: aliases, error: aliasError, isLoading: isLoadingAlias } = useGetAllAliasesQuery();
    let { data: clientVehicleStatuses, error: clientVehicleStatusesError, loading: clientVehicleStatusesLoading } = useGetStatusesForClientQuery( vehicleDetails?.clientAcccountId ?? 0 )
    
    clientVehicleStatuses = clientVehicleStatuses || [];

    let [deleteVehicleDetail] = useDeleteVehicleDetailMutation();
    let [deleteActivityLog] = useDeleteActivityMutation();
    let [updateStatus, { isLoadingUpdate }] = useMoveToStatusMutation();

    activityLogData = activityLogData || [];

    const clientVehicleStatusesLookup = arrayToObject(clientVehicleStatuses);

    const getStatusName = (value) => {
        let statusObj = clientVehicleStatusesLookup?.[value];
        return statusObj.name
    }

    const lotLookup = arrayToObject(lots);
    const deletedLotLookup = arrayToObject(deletedLots);

    activityLogData = activityLogData.map(a => ({
        ...a,
        action: a.actionId ?
            <VehicleStatusView value={a.actionId} clientAcccountId={vehicleDetails?.clientAcccountId} /> :
            a.action,
        formattedDate: FormatService.formatDateTimeNoConversion(lotLookup?.[a?.lotId]?.ianaTimeZone ? FormatService.formatDateByTimeZone(a.date, lotLookup?.[a?.lotId]?.ianaTimeZone) : a.date)
    }))


    const notActivities = activityLogData.filter(a => !a.activityLogId);
    const activities = orderBy(activityLogData.filter(a => a.activityLogId), ['activityDate'], ['desc']);

    const activityGroups = [];

    const groupedActivities = groupBy(activities, 'workOrderId');

    Object.keys(groupedActivities).map(workOrderId => {
        const lastActivity = groupedActivities[workOrderId]?.[0];
        activityGroups.push({
            ...lastActivity,
            subActivities: groupedActivities[workOrderId]?.filter(a => a.activityLogId !== lastActivity.activityLogId)
        });
    });

    let activityLog = orderBy([...notActivities, ...activityGroups], ['date'], ['desc']);

    const findLot = (lot_id) => {
        return lotLookup?.[lot_id] || {};
    }

    const findLotName = (lot_id) => {
        let lot = lotLookup?.[lot_id]
        if (lot) {
            return lot?.name
        } else {
            lot = deletedLotLookup?.[lot_id]
            return lot ? `${lot?.name} (Deleted)` : ""
        }
    }

    const mapExportData = v => {
        let exportData = {
            VIN: vehicleDetails?.descriptor,
            "Asset ID": vehicleDetails?.assetId,
            Date: v.date,
            Action: `${v.actionId ? getStatusName(v.actionId) : v.action} ${aliases?.find(a => a.activityStatusId === v.activityId && a.clientAccountId === vehicleDetails?.clientAccountId)?.alias ?? activityStatusById?.[v.activityId]?.name ?? ''}`,
            Lot: findLot(v.lotId)?.name,
            "Requested Date": v.requestedDate,
            "Days Completed In": v.daysCompletedIn ? v.daysCompletedIn : "",
            "Within SLA": getWithinSla(v),
            "Asset Readiness": v.readinessStatus
        };

        if (isAdmin) {
            exportData.Cost = v.cost;
            exportData.Revenue = v.revenue;
        }

        return exportData;
    };

    const moveToStatus = async (activityLogId, newStatus) => {
        const res = await updateStatus({
            activityLogIds: [activityLogId],
            moveToStatus: newStatus
        });
        if (res?.error) {
            NotificationProvider.error(`An error occured while updating activity, please try again.`);
            return;
        } else {
            NotificationProvider.success('Successfully updated the activity');
        }
    }

    const approveActivity = async (activity) => {
        await moveToStatus(activity?.activityLogId, activityStatuses.PricingApprovedByClient);
    }

    const rejectActivity = async (activity) => {
        await moveToStatus(activity?.activityLogId, activityStatuses.Cancelled);
    }

    // function editActivityLog(activity) {
    //     if (activity.activityLogId) {
    //         setActivityLogToEdit(activity);
    //     }
    //     if (activity.vehicleDetailsId) {
    //         setVehicleDetailsToEdit(activity);
    //     }
    // }

    function showMechanicalWork(activity) {
        let linkWork = `/workorder/${activity.workOrderId}`;
        history.push(linkWork);
    }

    function deleteActivity(activity) {
        setOpenPopup(true);
        if (activity.vehicleDetailsId) {
            setVehicleDetailToDelete(activity);
            return;
        }

        if (activity.activityLogId) {
            setActivityToDelete(activity);
        }
    }

    const saveActivity = (vehicleDetailsId, date) => {
        setVehicleDetailsToEdit(null);
        setActivityLogToEdit(null);
        refetchActivityLog();
    };

    const getWithinSla = activity => {
        if (activity.withinSla === null) {
            return "";
        }

        return activity.withinSla ? "Yes" : "No";
    };

    const onDeleteActivity = async () => {
        setOpenPopup(true);
        setIsDeleting(true);

        const result = vehicleDetailToDelete ? await deleteVehicleDetail(vehicleDetailToDelete.vehicleDetailsId) : await deleteActivityLog(activityToDelete.activityLogId);
        if (result.error) {
            NotificationProvider.error("Failed to delete the activity");
        } else {
            NotificationProvider.success("Successfully deleted the activity");
        }

        setIsDeleting(false);
        setOpenPopup(false);
        setVehicleDetailToDelete(null);
        setActivityToDelete(null);
    }

    let client = clients?.find(c => c.clientAccounts.find(ca => ca.id === vehicleDetails?.customerId));

    const getNotesForActivity = (activity) => {
        const type = activity?.activityLogId ? NoteEntityTypes.ACTIVITY : activity?.vehicleDetailsId ? NoteEntityTypes.VEHICLE_DETAIL : null;
        //For activities we show the notes for the whole group
        const ids = activity?.activityLogId ? [activity?.activityLogId, ...(activity?.subActivities?.map(a => a.id))] : [activity?.vehicleDetailsId];
        if (!type) return [];
        return allvehicleActivityNotes?.filter(note => note.entityType == type && ids.includes(note.entityId));
    }

    const getIsActivity = (activity) => {
        return !!activity?.activityLogId;
    }
    const getIsVechileDetail = (activity) => {
        return !!activity?.vehicleDetailsId;
    }

    const supportsNotes = (activity) => {
        return (getIsActivity(activity) && activity?.subActivities) || getIsVechileDetail(activity);
    }

    const activityColumns = [
        {
            key: 'date',
            label: 'Date',
            component: (activity) => (
                <Grid container alignItems='center'>
                    <Grid xs={9} item>{activity.formattedDate}</Grid>
                    <Authorize profile={permissionProfiles.ASSETS.VEHICLE_ACTIVITY_VIEW_AUDIT}>
                        <Grid xs={1} item><EntityAuditTooltip
                            entity={{ ...activity, createdDate: activity.createdDate ?? activity.formattedDate }} /></Grid>
                    </Authorize>
                </Grid>
            ),
            size: 2
        },
        {
            key: 'action',
            label: 'Action',
            component: (activity) => (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                    <div>
                        {activity.action}{' '}<ActivityStatusAliasView activityIds={[activity?.activityId ?? vehicleDetailsToEdit?.activityId]} clientAccountId={vehicleDetails?.clientAccountId} readonly={true} />{activity.cancelledDate ? ' (cancelled)' : ''}
                    </div>
                    {activity.loadId ? <LoadButton latestLoadID={activity.loadId} /> : activity.reservationId ? <ReservationButton reservationId={activity.reservationId} /> : ''}
                </div>
            ),
            size: 1
        },
        {
            label: 'Mileage',
            key: 'mileage',
            size: 1,
            component: (activity) => (
                <>{activity?.mileage}</>
            )
        },
        // {
        //     key: 'pendingApproval',
        //     label: '',
        //     component: (activity) => (
        //         <>{getIsActivity(activity) && <ActivityPriceError activity={activity} />}</>
        //     )
        // },
        {
            key: 'lot',
            label: 'Lot',
            component: (activity) => (
                <>{findLotName(activity.lotId)}</>
            ),
            size: 1
        },
        {
            key: 'requestedCompletionDate',
            label: 'Requested Completion Date',
            component: (activity) => (
                <>{FormatService.formatDate(activity.requestedCompletionDate)}</>
            ),
            size: 1
        },
        {
            key: 'withinSla',
            label: 'Within SLA',
            component: (activity) => (
                <>{getWithinSla(activity)}</>
            ),
            size: 1

        },
        {
            key: 'daysCompletedIn',
            label: 'Days Completed In',
            profile: permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_ACTIVITY_DAYS_COMPLETED_IN_COLUMN,
            component: (activity) => (
                <>{activity.daysCompletedIn == null || activity.daysCompletedIn == undefined ? "-" : activity.daysCompletedIn}</>
            ),
            size: 1

        },
        {
            key: 'internalCost',
            label: 'Internal Cost',
            profile: permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_ACTIVITY_LOG_INTERNAL_COST_COLUMN,
            component: (activity) => (
                <>{FormatService.formatCurrency(activity.cost)}</>
            ),
            size: 1
        },
        {
            key: 'charge',
            label: 'Charge',
            profile: permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_ACTIVITY_LOG_CHARGE_COLUMN,
            component: (activity) => (
                <>{FormatService.formatCurrency(activity.revenue)}</>
            ),
            size: 1
        },
        {
            key: 'notes',
            label: '',
            profile: permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_ADD_EDIT_NOTE_ACTIVITY,
            component: (activity) => (
                <>{supportsNotes(activity) && <NotesTooltip notes={getNotesForActivity(activity)}
                    entityType={activity?.activityLogId ? NoteEntityTypes.ACTIVITY : activity?.vehicleDetailsId ? NoteEntityTypes.VEHICLE_DETAIL : null}
                    entityId={activity?.activityLogId ?? activity?.vehicleDetailsId} editPermissionProfile={permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_ADD_EDIT_NOTE_ACTIVITY} />}</>
            ),
        },
        {
            key: 'attachments',
            label: '',
            component: (activity) => (
                <>{(getIsActivity(activity) && activity?.subActivities) && <AttachmentsTooltip entityType={AttachmentEntityTypes.ACTIVITY} entityId={activity?.activityLogId} />}</>
            ),
        },
        {
            key: 'mechanical',
            label: '',
            profile: permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_EDIT_WO,
            component: (activity) => (
                <>{
                    activity.id ?
                        <IconButton size='small' className={activityLogClasses.actionButton}
                            variant="outlined"
                            onClick={() => showMechanicalWork(activity)}>
                            <IconActivityDefault />
                        </IconButton>
                        : null

                }</>
            )
        },
        {
            key: 'actions',
            label: 'Actions',
            profile: permissionProfiles.ASSETS.SHOW_ACTIONS_MENU,
            component: (activity) => (
                <>{showActions(activity) ? <RowActions actions={rowActions} showActionsInMenu={true} cellData={activity} /> : null}</>
            ),
        }
    ]

    const rowActions = (activity) => {
        const actions = [];

        if (activity.activityLogId) {
            actions.push({
                label: 'Edit',
                profile: permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_EDIT_ACTIVITY_LOG,
                component: (
                    <Button
                        startIcon={<IconEdit />}
                        onClick={() => setActivityLogToEdit(activity)}
                        variant="text"
                        className={activityLogClasses.actionButton}
                    >
                        Edit
                    </Button>
                ),
            });
        }

        if (activity.vehicleDetailsId) {
            actions.push({
                label: 'Edit',
                profile: permissionProfiles.ASSETS.EDIT_VEHICLE_STATUS,
                component: (
                    <Button
                        startIcon={<IconEdit />}
                        onClick={() => setVehicleDetailsToEdit(activity)}
                        variant="text"
                        className={activityLogClasses.actionButton}
                    >
                        Edit
                    </Button>
                ),
            });
        }

        actions.push({
            label: 'Delete',
            profile: permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_DELETE_ACTIVITY_LOG,
            component:
                <>
                    <Tooltip
                        title={activity.systemGenerated ? 'This activity was generated by the system and should not be deleted' : ''}>
                        <div>
                            <Button
                                startIcon={<IconDeleteBlue size='small' width={15} />}
                                disabled={activity.systemGenerated}
                                onClick={() => deleteActivity(activity)}
                                variant='text'
                                className={activityLogClasses.actionButton}
                            >
                                Delete
                            </Button>
                        </div>
                    </Tooltip>
                </>,
        });

        if (activityCanBeApproved(activity)) {
            actions.push({
                label: 'Approve',
                profile: permissionProfiles.ACTIVITY.APPROVE_PENDING_CLIENT,
                component:
                    <>
                        <Button
                            startIcon={<IconApprove size={16} />}
                            onClick={() => approveActivity(activity)}
                            variant='text'
                            className={activityLogClasses.actionButton}
                            disabled={isLoadingUpdate}
                        >
                            Approve
                        </Button>
                    </>,
            },
                {
                    label: 'Reject',
                    profile: permissionProfiles.ACTIVITY.APPROVE_PENDING_CLIENT,
                    component:
                        <>
                            <Button
                                startIcon={<IconReject size={16} />}
                                onClick={() => rejectActivity(activity)}
                                variant='text'
                                className={activityLogClasses.actionButton}
                                disabled={isLoadingUpdate}
                            >
                                Reject
                            </Button>
                        </>,
                });
        }

        return actions;
    };

    const activityCanBeApproved = (activity) => {
        return activity?.activityId == activityStatuses.PendingClientApproval && !activity?.isSubActivity;
    }

    const showActions = (activity) => {
        const canEditActivity = !(activity.loadId || activity.reservationId);
        const canApprove = hasPermission(permissions.ACTIVITIES.APPROVE_PENDING_CLIENT.key) && activityCanBeApproved(activity);
        const canEditActivityLog = hasPermission(permissions.VEHICLE.ASSETS_DETAIL_PAGE_EDIT_ACTIVITY_LOG.key) && activity.activityLogId;
        const canEditVehicleStatus = hasPermission(permissions.VEHICLE.EDIT_VEHICLE_STATUS.key) && activity.vehicleDetailsId;
        const canDelete = hasPermission(permissions.VEHICLE.ASSETS_DETAIL_PAGE_DELETE_ACTIVITY_LOG.key);

        return canEditActivity && (canDelete || canApprove || canEditActivityLog || canEditVehicleStatus || isOwner);
    };


    const Row = ({ index, style }) => (
        <ListItem style={style} key={index} >
            <ActivityItem activity={activityLog?.[index]}
                index={index} activityColumns={activityColumns} expandedItems={expandedItems} setExpandedItems={setExpandedItems} />
        </ListItem>
    );

    const getItemSize = (index) => {
        let height = 85;
        const activity = activityLog?.[index];
        if (expandedItems?.includes(index)) {
            height += (85 * activity?.subActivities?.length)
        }
        return height;
    }

    const ref = useResetCache(activityLog);

    return (
        <>
            <Paper style={{ position: 'relative', height: '35rem' }} className={classes.card} elevation={1} id="activityLog">
                <Grid container direction="row" alignItems="center" spacing={2} className={classes.titleRow}>
                    <Grid container alignItems="center">
                        <img src="/icons/icon-log.svg" className={classes.icon} alt="Activity Log" />
                        <h2 className={classes.title}>Activity Log</h2>
                        <div container className={classes.exportButtonWrapper}>
                            <Authorize profile={permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_ADD_ACTIVITY_LOG}>
                                <AddActivity vehicleId={id} lotId={vehicleDetails?.lotId} clientAccountId={client?.clientAccountId}
                                    onClose={refetchActivityLog} vehicleTypeId={vehicleDetails?.vehicleTypeId}
                                    vehicleDetails={vehicleDetails} />
                            </Authorize>
                            <Authorize profile={permissionProfiles.ASSETS.ASSETS_DETAIL_PAGE_ACTIVITY_LOG_EXPORT}>
                                <ExportButton fileLabel="ActivityLog" data={activityLog} mapExportData={mapExportData}
                                    vin={vehicleDetails?.descriptor} />
                            </Authorize>
                        </div>
                    </Grid>
                </Grid>
                <Grid container className={classes.activityLogContainer}>
                    <Grid container direction='column'>
                        <Grid container item alignItems="center" className={activityLogClasses.headerRow}>
                            {activityColumns.map(column =>
                                <Authorize profile={column.profile}>
                                    <Grid className={activityLogClasses.activityLogHeader} key={`header_${column.key}`} item
                                        xs={column.size}>
                                        {column.label}
                                    </Grid>
                                </Authorize>
                            )}
                        </Grid>
                        <AutoSizer >
                            {({ height, width }) => (
                                <VariableSizeList
                                    className="List"
                                    height={height + 300}
                                    itemCount={activityLog?.length}
                                    itemSize={getItemSize}
                                    width={width}
                                    ref={ref}
                                    itemKey={index => index}
                                >
                                    {Row}
                                </VariableSizeList>
                            )}
                        </AutoSizer>
                    </Grid>
                </Grid>
            </Paper>

            {
                !!vehicleDetailsToEdit &&
                <EditVehicleDetails vehicleDetails={vehicleDetailsToEdit} onCancel={() => setVehicleDetailsToEdit(null)}
                    onConfirm={saveActivity} vehicleId={id} />
            }
            {
                !!activityLogToEdit &&
                <EditActivityLog
                    clientAccountId={client?.clientAccountId}
                    activityLog={activityLogToEdit}
                    onCancel={() => setActivityLogToEdit(null)}
                    onConfirm={saveActivity}
                    vehicleTypeId={vehicleDetails?.vehicleTypeId}
                />
            }
            <ConfirmationPopup
                title={'Delete Activity'}
                onCancel={() => setOpenPopup(false)}
                onConfirm={() => onDeleteActivity()}
                open={openPopup}
                loading={isDeleting}
            >
                <div>{`Are you sure you want to delete this activity?`}</div>
            </ConfirmationPopup>

        </>
    );
};

export default VehicleActivityLog;

const ActivityItem = ({ index, activity, activityColumns, expandedItems, setExpandedItems }) => {

    const classes = vehicleActivityLogStyle();

    const onExpand = () => {
        if (expandedItems?.includes(index)) {
            let filteredList = expandedItems.filter(l => l != index)
            setExpandedItems(filteredList);
        } else {
            setExpandedItems([...expandedItems, index]);
        }
    }

    const expanded = () => {
        return expandedItems?.includes(index);
    }

    const hasSubItems = !!activity?.subActivities?.length;
    return (
        <Grid container alignItems='center' item
            className={`${classes.activityItem} ${hasSubItems && expanded() && classes.expandedGroup}`}>
            <Grid container alignItems='center' className={`${hasSubItems && expanded() && classes.expandedRow}`}>
                <ActivityRow
                    activity={activity}
                    index={index}
                    activityColumns={activityColumns}
                    expandIcon={hasSubItems &&
                        <IconButton size='small' className={`${classes.expandIcon} ${expanded() && classes.expanded}`}
                            onClick={() => onExpand()}><ChevronRightIcon /></IconButton>}
                />
            </Grid>
            {!!activity?.subActivities?.length &&
                <Collapse in={expanded()} timeout="auto" unmountOnExit className={classes.collapseWrapper}>
                    <Grid container alignItems='center' direction='column' spacing={1}>
                        {activity?.subActivities?.map((subActivity, subIndex) => <ActivityRow activity={subActivity}
                            index={subIndex}
                            activityColumns={activityColumns} isSubActivity={true} />)}
                    </Grid>
                </Collapse>}
        </Grid>
    )
}

const ActivityRow = ({ index, activity, activityColumns, expandIcon, isSubActivity = false }) => {
    const classes = vehicleActivityLogStyle();
    const flagReadOnly = !isAuthorized(permissionProfiles.ASSETS.ASSETS_PAGE_FLAG_ADD_REMOVE);
    return (
        <Grid container alignItems='center'>
            {activity.activityLogId && !isSubActivity &&
                <Grid className={classes.flag}>
                    <FlagAsset
                        iconOnly
                        selectedRows={[activity?.id]}
                        allData={[activity]}
                        entityType={FlagEntityTypes.ACTIVITY}
                        readonly={flagReadOnly}
                    />
                </Grid>}
            {expandIcon}
            {activityColumns.map(column =>
                <Authorize profile={column.profile}>
                    <Grid alignItems='center' className={classes.activityCell} key={`${index}_${column.key}`} item xs={column.size}>
                        {column.component({ ...activity, isSubActivity })}
                    </Grid>
                </Authorize>
            )}
        </Grid>
    )
}
